import { Affix } from 'antd';
import styled from 'styled-components';

export default styled(Affix)`
	// Add your styles here
`;
